import PromotionChallengeTransactionTable from './PromotionChallengeTransactionTable'
import { withPromotionChallengeTransactionTable } from './withPromotionChallengeTransactionTable'

const ConnectedPromotionChallengeTransactionTable =
  withPromotionChallengeTransactionTable(PromotionChallengeTransactionTable)

export { ConnectedPromotionChallengeTransactionTable as PromotionChallengeTransactionTable }
